import Jobs from 'components/view/jobs/Index'
import {tabNames, TabType} from 'router/settings'
import defaultJobsState from 'redux/jobs/state'
import {GridStateParamsType} from 'commonTypes'
import {StateDeclaration} from '@uirouter/core'

const jobsState = {
  name: 'jobs',
  url: '/jobs',
  component: Jobs,
  resolve: [{
    token: 'title',
    deps: ['$transition$'],
    resolveFn: () => tabNames[TabType.jobs],
  }],
  params: {
    pagination: defaultJobsState.gridSession.pagination,
    sorting: defaultJobsState.gridSession.sorting,
    filters: defaultJobsState.gridSession.filters,
  } as GridStateParamsType,
} as StateDeclaration

export default jobsState
